/* Maison: header, reveals and the scroll-led scenes on the homepage */
(() => {
  const root = document.documentElement;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const smooth = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const lerp = (a, b, t) => a + (b - a) * t;
  root.classList.add('m-js');

  /* The header is clear over the opening photograph and turns solid once you move */
  const head = document.querySelector('.header-section');
  if (head && document.body.classList.contains('m-home')) {
    const nav = head.querySelector('riaz-navigation');
    const pointer = matchMedia('(hover: hover)');
    let queued = false;
    const sync = () => {
      queued = false;
      const busy = (pointer.matches && head.matches(':hover')) || head.querySelector(':focus-visible, .riaz-root-disclosure[open]') || nav?.hasAttribute('data-open');
      head.classList.toggle('m-clear', scrollY < 40 && !busy);
    };
    const later = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };
    sync();
    addEventListener('scroll', later, { passive: true });
    ['pointerenter', 'pointerleave', 'focusin', 'focusout'].forEach((t) => head.addEventListener(t, later));
    head.addEventListener('toggle', later, true);
    if (nav) new MutationObserver(later).observe(nav, { attributes: true, attributeFilter: ['data-open'] });
  }

  /* Buttons in the opening glide down to their section */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.mh a[href^="#"]');
    const target = link && document.getElementById(link.getAttribute('href').slice(1));
    if (!target || calm) return;
    e.preventDefault();
    const from = scrollY, to = target.getBoundingClientRect().top + scrollY, dist = to - from;
    const t0 = performance.now(), dur = Math.min(1500, 600 + Math.abs(dist) * 0.3);
    const step = (now) => {
      const k = clamp((now - t0) / dur);
      scrollTo(0, from + dist * smooth(k));
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  });

  /* Words of a heading, each in its own mask so it can rise into place */
  const split = (el, cls, lift) => {
    let i = 0;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 1) return walk(n);
        if (n.nodeType !== 3) return;
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) return frag.append(' ');
          const word = document.createElement('span');
          word.className = cls;
          if (lift) {
            const inner = document.createElement('span');
            inner.textContent = part;
            inner.style.setProperty('--i', i++);
            word.append(inner);
          } else {
            word.textContent = part;
          }
          frag.append(word);
        });
        n.replaceWith(frag);
      });
    };
    walk(el);
    return [...el.querySelectorAll('.' + cls)];
  };

  if (!calm) document.querySelectorAll('[data-m-split]').forEach((el) => split(el, 'm-w', true));

  const reveal = new IntersectionObserver((list) => {
    list.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('m-in');
      reveal.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
  document.querySelectorAll('[data-m-reveal], [data-m-split]').forEach((el) => reveal.observe(el));

  /* Numbers count up the first time they are seen */
  const counter = new IntersectionObserver((list) => {
    list.forEach((e) => {
      if (!e.isIntersecting) return;
      counter.unobserve(e.target);
      const el = e.target, end = parseFloat(el.dataset.mCount), dp = +(el.dataset.mDecimals || 0);
      if (calm || !end) return;
      const t0 = performance.now(), dur = 1800;
      const step = (now) => {
        const k = 1 - Math.pow(1 - clamp((now - t0) / dur), 4);
        el.textContent = (end * k).toLocaleString('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp });
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-m-count]').forEach((el) => counter.observe(el));

  /* Everything below runs from one frame loop, and only for scenes on screen */
  const scenes = [];
  const near = new IntersectionObserver((list) => list.forEach((e) => { e.target.__near = e.isIntersecting; }), { rootMargin: '25% 0px' });
  const scene = (el, fn) => { el.__near = true; near.observe(el); scenes.push([el, fn]); };

  /* Opening: the photograph drifts, the words lift away, gold dust floats */
  const hero = document.querySelector('[data-mh]');
  if (hero && !calm) {
    const media = hero.querySelector('[data-mh-media]'), inner = hero.querySelector('[data-mh-inner]');
    scene(hero, () => {
      const y = Math.max(0, scrollY), h = hero.offsetHeight;
      if (y > h) return;
      media.style.transform = `translate3d(0, ${y * 0.22}px, 0)`;
      inner.style.transform = `translate3d(0, ${y * 0.1}px, 0)`;
      inner.style.opacity = clamp(1 - y / (h * 0.62));
    });
    dust(hero.querySelector('[data-mh-dust]'), hero);
  }

  /* A statement that lights up word by word as it is read */
  document.querySelectorAll('[data-m-words]').forEach((el) => {
    const words = split(el, 'm-sw', false);
    if (calm) return;
    let last = -1;
    scene(el, () => {
      const r = el.getBoundingClientRect(), vh = innerHeight;
      const p = clamp((vh * 0.82 - r.top) / (r.height + vh * 0.28));
      const lit = p * (words.length + 2);
      if (Math.abs(lit - last) < 0.02) return;
      last = lit;
      words.forEach((w, i) => w.style.setProperty('--o', (0.13 + 0.87 * clamp(lit - i)).toFixed(3)));
    });
  });

  /* The craft: the camera moves close to each part of the embroidery */
  const craft = document.querySelector('[data-mk]');
  if (craft) {
    const stage = craft.querySelector('[data-mk-stage]'), cam = craft.querySelector('[data-mk-cam]'), ring = craft.querySelector('[data-mk-ring]');
    const steps = [...craft.querySelectorAll('[data-mk-step]')], ticks = [...craft.querySelectorAll('[data-mk-tick]')];
    const shots = steps.map((s) => ({ x: +s.dataset.x || 0.5, y: +s.dataset.y || 0.5, z: Math.max(1, +s.dataset.z || 1) }));
    const iw = +cam?.dataset.w || 1, ih = +cam?.dataset.h || 1;
    let active = -1, eased = 0;
    if (cam) { cam.style.width = `${iw}px`; cam.style.height = `${ih}px`; }

    const place = (shot) => {
      const W = stage.clientWidth, H = stage.clientHeight;
      const s = Math.max(W / iw, H / ih) * shot.z;
      const tx = clamp(W / 2 - shot.x * iw * s, W - iw * s, 0), ty = clamp(H / 2 - shot.y * ih * s, H - ih * s, 0);
      cam.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(${s})`;
      return [shot.x * iw * s + tx, shot.y * ih * s + ty];
    };
    const show = (i, zoomed) => {
      if (i === active) return;
      active = i;
      steps.forEach((s, j) => { s.classList.toggle('is-on', j === i); s.classList.toggle('is-past', j < i); });
      ring.classList.remove('is-on');
      if (zoomed) requestAnimationFrame(() => requestAnimationFrame(() => ring.classList.add('is-on')));
    };

    if (calm || !cam) {
      steps.forEach((s) => s.classList.add('is-on'));
    } else {
      scene(craft, () => {
        const r = craft.getBoundingClientRect(), n = shots.length;
        const target = clamp(-r.top / Math.max(1, r.height - innerHeight));
        eased = Math.abs(target - eased) < 0.0005 ? target : lerp(eased, target, 0.16);
        const t = Math.min(eased * n, n - 0.0001), i = Math.floor(t), u = t - i;
        const next = Math.min(i + 1, n - 1), k = smooth(clamp((u - 0.62) / 0.38));
        const a = shots[i], b = shots[next];
        const [px, py] = place({ x: lerp(a.x, b.x, k), y: lerp(a.y, b.y, k), z: lerp(a.z, b.z, k) });
        const now = u < 0.81 ? i : next;
        show(now, shots[now].z > 1.15);
        ring.style.transform = `translate3d(${px}px, ${py}px, 0)`;
        ring.style.opacity = k > 0 && k < 1 ? 0 : '';
        ticks.forEach((tick, j) => tick.style.setProperty('--p', clamp(t - j).toFixed(3)));
      });
      addEventListener('resize', () => { active = -1; }, { passive: true });
    }
  }

  /* Masonic bodies: the gallery travels sideways while the page scrolls down */
  const bodies = document.querySelector('[data-mb]');
  if (bodies) {
    const track = bodies.querySelector('[data-mb-track]'), bar = bodies.querySelector('[data-mb-bar]');
    const wide = matchMedia('(min-width: 900px)');
    let dist = 0;
    const size = () => {
      if (!wide.matches) { bodies.style.height = ''; dist = 0; return; }
      dist = Math.max(0, track.scrollWidth - innerWidth);
      bodies.style.height = `${innerHeight + dist}px`;
    };
    size();
    addEventListener('resize', size, { passive: true });
    addEventListener('load', size);
    wide.addEventListener('change', size);
    let eased = 0;
    scene(bodies, () => {
      if (!dist) return;
      const r = bodies.getBoundingClientRect();
      const target = clamp(-r.top / Math.max(1, r.height - innerHeight));
      eased = calm ? target : lerp(eased, target, 0.18);
      track.style.transform = `translate3d(${(-eased * dist).toFixed(1)}px, 0, 0)`;
      bar?.style.setProperty('--mb-p', eased.toFixed(4));
    });
  }

  /* Pieces: arrows step through the rail */
  document.querySelectorAll('.mq').forEach((sec) => {
    const rail = sec.querySelector('[data-mq-rail]');
    const by = (dir) => {
      const item = rail.querySelector('.mq-item');
      const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 20) : 320;
      rail.scrollBy({ left: dir * step * 2, behavior: calm ? 'auto' : 'smooth' });
    };
    sec.querySelector('[data-mq-prev]')?.addEventListener('click', () => by(-1));
    sec.querySelector('[data-mq-next]')?.addEventListener('click', () => by(1));
  });

  /* Reviews: one voice at a time */
  document.querySelectorAll('[data-mv]').forEach((sec) => {
    const quotes = [...sec.querySelectorAll('[data-mv-quote]')], dots = [...sec.querySelectorAll('[data-mv-dot]')];
    if (quotes.length < 2) return;
    let at = 0, timer = 0, paused = false, seen = false;
    const go = (i) => {
      at = (i + quotes.length) % quotes.length;
      quotes.forEach((q, j) => q.classList.toggle('is-on', j === at));
      dots.forEach((d, j) => d.setAttribute('aria-selected', String(j === at)));
    };
    const tick = () => {
      clearTimeout(timer);
      if (calm || paused || !seen) return;
      timer = setTimeout(() => { go(at + 1); tick(); }, 6500);
    };
    sec.querySelector('[data-mv-prev]')?.addEventListener('click', () => { go(at - 1); tick(); });
    sec.querySelector('[data-mv-next]')?.addEventListener('click', () => { go(at + 1); tick(); });
    dots.forEach((d, j) => d.addEventListener('click', () => { go(j); tick(); }));
    sec.addEventListener('pointerenter', () => { paused = true; tick(); });
    sec.addEventListener('pointerleave', () => { paused = false; tick(); });
    sec.addEventListener('focusin', () => { paused = true; tick(); });
    sec.addEventListener('focusout', () => { paused = false; tick(); });
    new IntersectionObserver(([e]) => { seen = e.isIntersecting; tick(); }, { threshold: 0.4 }).observe(sec);
  });

  /* Gentle depth on large photographs */
  if (!calm) {
    document.querySelectorAll('[data-m-parallax]').forEach((el) => {
      const f = parseFloat(el.dataset.mParallax) || 0.06, host = el.parentElement;
      scene(host, () => {
        const r = host.getBoundingClientRect();
        el.style.translate = `0 ${clamp((r.top + r.height / 2 - innerHeight / 2) * -f, -140, 140).toFixed(1)}px`;
      });
    });
  }

  if (scenes.length) {
    const loop = () => {
      for (const [el, fn] of scenes) if (el.__near) fn();
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  /* Gold dust drifting up through the light, drawn on a small canvas */
  function dust(canvas, host) {
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const glow = document.createElement('canvas');
    glow.width = glow.height = 32;
    const g = glow.getContext('2d'), grad = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    grad.addColorStop(0, 'rgba(255,240,200,1)');
    grad.addColorStop(0.25, 'rgba(240,206,140,.55)');
    grad.addColorStop(1, 'rgba(240,206,140,0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, 32, 32);
    let W = 0, H = 0, dots = [], on = false, last = 0;
    const make = (fresh) => ({
      x: W * (0.3 + Math.random() * 0.7), y: fresh ? H + 10 : Math.random() * H,
      r: 2 + Math.random() * 6, v: 0.1 + Math.random() * 0.32, a: 0.15 + Math.random() * 0.55,
      w: Math.random() * Math.PI * 2, s: 0.004 + Math.random() * 0.012
    });
    const size = () => {
      const dpr = Math.min(devicePixelRatio || 1, 1.5);
      W = host.clientWidth; H = host.clientHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      dots = Array.from({ length: W < 700 ? 22 : 46 }, () => make(false));
    };
    const draw = (now) => {
      if (!on) return;
      const dt = Math.min(48, now - (last || now)) / 16.7;
      last = now;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (const d of dots) {
        d.y -= d.v * dt; d.w += d.s * dt;
        if (d.y < -20) Object.assign(d, make(true));
        const tw = 0.55 + 0.45 * Math.sin(d.w * 3);
        ctx.globalAlpha = d.a * tw;
        ctx.drawImage(glow, d.x + Math.sin(d.w) * 14 - d.r, d.y - d.r, d.r * 2, d.r * 2);
      }
      requestAnimationFrame(draw);
    };
    size();
    addEventListener('resize', size, { passive: true });
    new IntersectionObserver(([e]) => {
      const was = on;
      on = e.isIntersecting && !document.hidden;
      if (on && !was) { last = 0; requestAnimationFrame(draw); }
    }).observe(host);
    document.addEventListener('visibilitychange', () => {
      const was = on;
      on = !document.hidden && host.getBoundingClientRect().bottom > 0;
      if (on && !was) { last = 0; requestAnimationFrame(draw); }
    });
  }
})();
